export default "__VITE_ASSET__BNgvjZjE__"